<div class="container" [formGroup]="formGroup">
  <div class="config-sections" formGroupName="config">
    <pdq-card variant="popover" color="white">
      <div class="card-content">
        <div class="section-header">
          <pdq-heading element="h6">Content</pdq-heading>
          <span class="section-subtitle">Title, subtitle, and their sizes.</span>
        </div>
        <pdq-divider></pdq-divider>
        <div>
          <div class="field">
            <span class="field-label">Display title</span>
            <div class="title-row">
              <pdq-input
                class="title-input"
                label="Display title"
                [labelHidden]="true"
                formControlName="titleText"></pdq-input>
              <pdq-button
                class="bold-toggle"
                variant="secondary"
                size="medium"
                label="B"
                [active]="configGroup.controls.titleTextBold.value"
                (onClick)="toggleBold()"></pdq-button>
            </div>
          </div>
          <pdq-dropdown formControlName="titleTextSize" title="Title size" [options]="textSizeOptions"></pdq-dropdown>
          <pdq-input label="Display subtitle" formControlName="infoText"></pdq-input>
          <pdq-dropdown formControlName="infoTextSize" title="Subtitle size" [options]="textSizeOptions"></pdq-dropdown>
        </div>
      </div>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <div class="card-content">
        <div class="section-header">
          <pdq-heading element="h6">Widget style</pdq-heading>
          <span class="section-subtitle">Logo, background, and border.</span>
        </div>
        <pdq-divider></pdq-divider>
        <div>
          <div class="toggle-row">
            <span class="toggle-label">Show Order Protection logo</span>
            <pdq-slide-toggle [defaultValue]="showLogo" (onToggle)="onShowLogoToggle($event)"></pdq-slide-toggle>
          </div>
          <pdq-dropdown
            formControlName="backgroundColor"
            title="Background"
            [options]="backgroundOptions"></pdq-dropdown>
          <div class="toggle-row">
            <span class="toggle-label">Border</span>
            <pdq-slide-toggle formControlName="showBorder"></pdq-slide-toggle>
          </div>
          @if (configGroup.controls.showBorder.value) {
            <div class="field-row">
              <pdq-dropdown
                formControlName="borderStyle"
                title="Stroke Style"
                [options]="borderStyleOptions"></pdq-dropdown>
              <pdq-dropdown formControlName="borderWidth" title="Width" [options]="borderWidthOptions"></pdq-dropdown>
              <pdq-dropdown
                formControlName="borderRadius"
                title="Corner Radius"
                [options]="borderRadiusOptions"></pdq-dropdown>
            </div>
          }
        </div>
      </div>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <div class="card-content">
        <div class="section-header">
          <pdq-heading element="h6">Action</pdq-heading>
          <span class="section-subtitle">How the shopper adds protection.</span>
        </div>
        <pdq-divider></pdq-divider>
        <div>
          <pdq-radio-group formControlName="actionButtonType">
            <pdq-radio-button
              [value]="ActionType.TOGGLE"
              text="Toggle"
              subText="Shopper flips a switch to add protection."></pdq-radio-button>
            <pdq-radio-button
              [value]="ActionType.CHECKBOX"
              text="Checkbox"
              subText="Shopper ticks a checkbox to add protection."></pdq-radio-button>
          </pdq-radio-group>
        </div>
      </div>
    </pdq-card>

    <pdq-card variant="popover" color="white">
      <div class="card-content">
        <div class="section-header">
          <pdq-heading element="h6">Disclaimer</pdq-heading>
          <span class="section-subtitle">Consent and coverage disclosures shown with the widget.</span>
        </div>
        <pdq-divider></pdq-divider>
        <div>
          <div class="toggle-row">
            <span class="toggle-label">Show info modal</span>
            <pdq-slide-toggle formControlName="showInfoModal"></pdq-slide-toggle>
          </div>
          <span class="section-subtitle"
            >The ⓘ beside the title opens Order Protection's full coverage details and policy — managed by Order
            Protection.</span
          >
          <div class="toggle-row">
            <span class="toggle-label">Show disclaimer</span>
            <pdq-slide-toggle formControlName="showDisclaimerText"></pdq-slide-toggle>
          </div>
          @if (configGroup.controls.showDisclaimerText.value) {
            <pdq-input label="Disclaimer text" formControlName="disclaimerTextOn"></pdq-input>
            <pdq-dropdown
              formControlName="disclaimerTextOnSize"
              title="Disclaimer size"
              [options]="textSizeOptions"></pdq-dropdown>
          }
        </div>
      </div>
    </pdq-card>
  </div>
</div>
